/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreditCardAuthRequestedResponse
 */
export interface CreditCardAuthRequestedResponse {
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthRequestedResponse
   */
  bookingId: string;
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthRequestedResponse
   */
  creditCardAuthRequested?: string | null;
}

/**
 * Check if a given object implements the CreditCardAuthRequestedResponse interface.
 */
export function instanceOfCreditCardAuthRequestedResponse(
  value: object
): value is CreditCardAuthRequestedResponse {
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  return true;
}

export function CreditCardAuthRequestedResponseFromJSON(
  json: any
): CreditCardAuthRequestedResponse {
  return CreditCardAuthRequestedResponseFromJSONTyped(json, false);
}

export function CreditCardAuthRequestedResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreditCardAuthRequestedResponse {
  if (json == null) {
    return json;
  }
  return {
    bookingId: json["booking_id"],
    creditCardAuthRequested:
      json["credit_card_auth_requested"] == null
        ? undefined
        : json["credit_card_auth_requested"],
  };
}

export function CreditCardAuthRequestedResponseToJSON(
  json: any
): CreditCardAuthRequestedResponse {
  return CreditCardAuthRequestedResponseToJSONTyped(json, false);
}

export function CreditCardAuthRequestedResponseToJSONTyped(
  value?: CreditCardAuthRequestedResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    booking_id: value["bookingId"],
    credit_card_auth_requested: value["creditCardAuthRequested"],
  };
}
